import { defineComponent as _defineComponent } from 'vue'
import { nextTick, onBeforeUnmount, ref, watch } from 'vue'
import { useI18n } from 'vue-i18n'
import { PontotelBotaoIcone, PontotelToggle } from '@Lar21/imaginii-web-components/lib/vue'
import type { OpcoesAvancadas } from '../../dominio/assistente.interface'
import { deslocamentoParaCaber, type ModoDeAcao } from './opcoesAvancadas'

/**
 * O botão de ajustes do cabeçalho do dock e o popover com os dois modos. Só
 * emite a escolha: quem guarda (store + localStorage) é a action
 * `definirModoDeAcao`. Fecha com Esc — sem deixar o Esc fechar o dock junto —
 * e com clique fora.
 */
const MARGEM_DO_POPOVER = 8

/** O primeiro ancestral que recorta o que vaza (o dock acoplado), ou a janela. */

export default /*@__PURE__*/_defineComponent({
  __name: 'OpcoesAvancadas',
  props: {
    opcoes: { type: Object, required: true }
  },
  emits: ["update:modo-de-acao"],
  setup(__props: any, { expose: __expose, emit: __emit }) {
  __expose();


const emit = __emit
const { t } = useI18n()

const raiz = ref<HTMLElement | null>(null)
const popover = ref<HTMLElement | null>(null)
const aberto = ref(false)
const estiloDoPopover = ref<Record<string, string>>({})
const idDoPopover = `opcoes-avancadas-${Math.random().toString(36).slice(2, 10)}`

function alternar (): void {
  aberto.value = !aberto.value
}

function fechar (): void {
  aberto.value = false
}

function mudar (modo: ModoDeAcao, ligado: boolean): void {
  emit('update:modo-de-acao', { modo, ligado: ligado === true })
}

/** Folga entre o popover e a borda de quem recorta, em px. */
function limiteDoPopover (elemento: HTMLElement): { left: number, right: number } {
  for (let atual = elemento.parentElement; atual; atual = atual.parentElement) {
    if (getComputedStyle(atual).overflowX !== 'visible') {
      const { left, right } = atual.getBoundingClientRect()
      return { left, right }
    }
  }
  return { left: 0, right: window.innerWidth }
}

async function caberNoLimite (): Promise<void> {
  estiloDoPopover.value = {}
  await nextTick()
  const elemento = popover.value
  if (!elemento || typeof window === 'undefined') return
  const { left, right } = elemento.getBoundingClientRect()
  const deslocamento = deslocamentoParaCaber({ left, right }, limiteDoPopover(elemento), MARGEM_DO_POPOVER)
  if (deslocamento !== 0) estiloDoPopover.value = { transform: `translateX(${Math.round(deslocamento)}px)` }
}

function aoClicarFora (evento: Event): void {
  const alvo = evento.target as Node | null
  if (raiz.value && alvo && !raiz.value.contains(alvo)) fechar()
}

watch(aberto, (estaAberto) => {
  if (typeof document === 'undefined') return
  if (estaAberto) void caberNoLimite()
  if (estaAberto) document.addEventListener('pointerdown', aoClicarFora, true)
  else document.removeEventListener('pointerdown', aoClicarFora, true)
})

onBeforeUnmount(() => {
  if (typeof document !== 'undefined') document.removeEventListener('pointerdown', aoClicarFora, true)
})

const __returned__ = { emit, t, raiz, popover, aberto, estiloDoPopover, idDoPopover, alternar, fechar, mudar, MARGEM_DO_POPOVER, limiteDoPopover, caberNoLimite, aoClicarFora, get PontotelBotaoIcone() { return PontotelBotaoIcone }, get PontotelToggle() { return PontotelToggle } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})